import Constants from '../utils/constants';

const CONFIG = Constants.SVG.CONFIG;
const INPUTS = Constants.TOPOLOGY_INPUTS;
const OPTIONS = Constants.TOPOLOGY_OPTIONS;
const ALTERATION_TYPES = Constants.SVG.ALTERATION_TYPES;
const LINK_TYPES = Constants.SVG.LINK_TYPES;
const SIGNAL_CHAIN_ITEMS = Constants.SIGNAL_CHAIN_ITEMS;
const SVG_IDS = Constants.SVG.SIGNAL_CHAIN_TO_SVG_ID_MAP;
const OUTPUT_VOLTAGE = Constants.SVG.OUTPUT_VOLTAGE;

let voltageOutputDac = {};
voltageOutputDac[CONFIG.BASE] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INTERNAL_VOLTAGE_REFERENCE.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'External_Reference_Dot' },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Amplifier' },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Buffer' },
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INVERTING_AMPLIFIER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INVERTING_BUFFER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Inverting_Buffer' },
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.OUTPUT_AMPLIFIER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_output_Amplifier' },
  { type: ALTERATION_TYPES.HIDE, id: OUTPUT_VOLTAGE.POSITIVE_DAC.HIDE },
  { type: ALTERATION_TYPES.RESIZE_VIEWBOX, height: 166 },
];

voltageOutputDac[CONFIG.CUSTOM_LABELS] = [
  { type: ALTERATION_TYPES.ADD_LINK, linkTypes: [LINK_TYPES.DAC], id: 'Vout_DAC_Name' },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.VOLTAGE_REFERENCE],
    id: SVG_IDS.VOLTAGE_REFERENCE.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.NON_INVERTING_BUFFER],
    id: SVG_IDS.NON_INVERTING_BUFFER.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.NON_INVERTING_AMP],
    id: SVG_IDS.NON_INVERTING_AMPLIFIER.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.INVERTING_BUFFER],
    id: SVG_IDS.INVERTING_BUFFER.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.INVERTING_AMP],
    id: SVG_IDS.INVERTING_AMPLIFIER.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.OUTPUT_AMP, SIGNAL_CHAIN_ITEMS.OUTPUT_BUFFER],
    id: SVG_IDS.OUTPUT_AMPLIFIER.NAME,
  },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.REFERENCE.ID },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.POSITIVE_DAC.ID },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.NEGATIVE_DAC.ID },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.OUTPUT.ID },
];

/**
 * Voltage Output Dac Reference Input
 */
voltageOutputDac[`${INPUTS.VOLTAGE_REFERENCE}${OPTIONS.INTERNAL}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.VOLTAGE_REFERENCE.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Amplifier' },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Buffer' },
];

voltageOutputDac[`${INPUTS.VOLTAGE_REFERENCE}${OPTIONS.EXTERNAL}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INTERNAL_VOLTAGE_REFERENCE.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: OUTPUT_VOLTAGE.POSITIVE_DAC.HIDE },
];

/**
 * Voltage Output Non-Inverting Input
 */
voltageOutputDac[`${INPUTS.NON_INVERTING}${OPTIONS.NON_INVERTING_BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Amplifier' },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Buffer' },
];

voltageOutputDac[`${INPUTS.NON_INVERTING}${OPTIONS.NON_INVERTING_NO_BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.NON_INVERTING_BUFFER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Amplifier' },
];

voltageOutputDac[`${INPUTS.NON_INVERTING}${OPTIONS.BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.NON_INVERTING_AMPLIFIER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Non-Inverting_Buffer' },
];

voltageOutputDac[`${INPUTS.NON_INVERTING}${OPTIONS.NO_BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.NON_INVERTING_AMPLIFIER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.NON_INVERTING_BUFFER.GROUP },
];

/**
 * Voltage Output Inverting Input
 */
voltageOutputDac[`${INPUTS.INVERTING}${OPTIONS.BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'No_Inverting_Buffer' },
  { type: ALTERATION_TYPES.HIDE, id: OUTPUT_VOLTAGE.NEGATIVE_DAC.HIDE },
  { type: ALTERATION_TYPES.CHANGE_TRANSFORM, id: 'REF_Name', transform: 'translate(45.38 112.56)' },
];

voltageOutputDac[`${INPUTS.INVERTING}${OPTIONS.NO_BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INVERTING_BUFFER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: OUTPUT_VOLTAGE.NEGATIVE_DAC.HIDE },
  { type: ALTERATION_TYPES.CHANGE_TRANSFORM, id: 'REF_Name', transform: 'translate(45.38 112.56)' },
];

voltageOutputDac[`${INPUTS.INVERTING}${OPTIONS.NONE}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INVERTING_AMPLIFIER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Inverting_Buffer' },
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INVERTING_BUFFER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'External_Reference_Dot' },
  { type: ALTERATION_TYPES.CHANGE_TRANSFORM, id: 'REF_Name', transform: 'translate(0.38 121.56)' },
];

/**
 * Voltage Output Output Input
 */
voltageOutputDac[`${INPUTS.OUTPUT}${OPTIONS.BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.OUTPUT_AMPLIFIER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_output_Amplifier' },
];

voltageOutputDac[`${INPUTS.OUTPUT}${OPTIONS.EXTERNAL_RESISTORS}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.OUTPUT_BUFFER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'No_output_Amplifier' },
];

voltageOutputDac[`${INPUTS.OUTPUT}${OPTIONS.NONE}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.OUTPUT_AMPLIFIER.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.OUTPUT_BUFFER.GROUP },
];

/**
 * Multiplying DAC Configuration
 */
let multiplyingDac = {};
multiplyingDac[CONFIG.BASE] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Neg_Buff' },
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Neg_Unbuff' },
  { type: ALTERATION_TYPES.HIDE, id: 'External_Res' },
];

multiplyingDac[CONFIG.CUSTOM_LABELS] = [
  { type: ALTERATION_TYPES.ADD_LINK, linkTypes: [LINK_TYPES.DAC], id: 'MDAC_Name' },
  { type: ALTERATION_TYPES.ADD_LINK, linkTypes: [SIGNAL_CHAIN_ITEMS.OUTPUT_AMP], id: SVG_IDS.OUTPUT_AMPLIFIER.NAME },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.VOLTAGE_REFERENCE],
    id: SVG_IDS.VOLTAGE_REFERENCE.NAME,
  },
  { type: ALTERATION_TYPES.ADD_LINK, linkTypes: [SIGNAL_CHAIN_ITEMS.BUFFER], id: SVG_IDS.BUFFER.NAME },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.INVERTING_AMP],
    id: SVG_IDS.INVERTING_AMPLIFIER.NAME,
  },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.REFERENCE.ID },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.DAC.ID },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.OUTPUT.ID },
];

/**
 * Multiplying Dac Input
 */
multiplyingDac[`${INPUTS.MULTIPLYING_DAC}${OPTIONS.NO_BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Neg_Buff' },
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Pos' },
];

multiplyingDac[`${INPUTS.MULTIPLYING_DAC}${OPTIONS.BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Neg_Unbuff' },
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Pos' },
  { type: ALTERATION_TYPES.HIDE, id: 'Internal_Res' },
];

multiplyingDac[`${INPUTS.MULTIPLYING_DAC}${OPTIONS.INVERTING}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Neg_Buff' },
  { type: ALTERATION_TYPES.HIDE, id: 'Unipolar_Neg_Unbuff' },
];

multiplyingDac[CONFIG.NO_INV_RES] = [
  { type: ALTERATION_TYPES.HIDE, id: 'External_Res' },
  { type: ALTERATION_TYPES.HIDE, id: 'Internal_Res' },
];

multiplyingDac[CONFIG.INTERNAL_INV_RES] = [{ type: ALTERATION_TYPES.HIDE, id: 'External_Res' }];

multiplyingDac[CONFIG.EXTERNAL_INV_RES] = [{ type: ALTERATION_TYPES.HIDE, id: 'Internal_Res' }];

let ioutVoutDac = {};
ioutVoutDac[CONFIG.BASE] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INTERNAL_VOLTAGE_REFERENCE.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: 'Vout' },
];

ioutVoutDac[CONFIG.CUSTOM_LABELS] = [
  { type: ALTERATION_TYPES.ADD_LINK, linkTypes: [LINK_TYPES.DAC], id: '_4_to_20_mA_DAC_Name' },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.VOLTAGE_REFERENCE],
    id: SVG_IDS.VOLTAGE_REFERENCE.NAME,
  },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.REFERENCE.ID },
  { type: ALTERATION_TYPES.HIDE, id: 'Vout' },
];

ioutVoutDac[`${INPUTS.RSET}${OPTIONS.INTERNAL}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.EXTERNAL_RSET.GROUP },
  { type: ALTERATION_TYPES.RESIZE_VIEWBOX, height: 136 },
];

ioutVoutDac[`${INPUTS.VOLTAGE_REFERENCE}${OPTIONS.INTERNAL}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.VOLTAGE_REFERENCE.GROUP },
];

ioutVoutDac[`${INPUTS.VOLTAGE_REFERENCE}${OPTIONS.EXTERNAL}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INTERNAL_VOLTAGE_REFERENCE.GROUP },
];

/**
 * TODO: Change label in future?
 * NOTE: If we ever allow this option we will need to hide this selection for the Sink Category
 **/
ioutVoutDac[`${INPUTS.IOUT_OR_VOUT}${OPTIONS.VOUT}`] = [
  // { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.VOLTAGE_REFERENCE.GROUP },
];

let fastPrecisionDac = {};
fastPrecisionDac[CONFIG.CUSTOM_LABELS] = [
  { type: ALTERATION_TYPES.ADD_LINK, linkTypes: [LINK_TYPES.DAC], id: 'FPDAC_Name' },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.VOLTAGE_REFERENCE],
    id: SVG_IDS.VOLTAGE_REFERENCE.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.NON_INVERTING_BUFFER],
    id: SVG_IDS.NON_INVERTING_BUFFER.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.NON_INVERTING_AMP],
    id: SVG_IDS.NON_INVERTING_AMPLIFIER.NAME,
  },
  {
    type: ALTERATION_TYPES.ADD_LINK,
    linkTypes: [SIGNAL_CHAIN_ITEMS.OUTPUT_AMP, SIGNAL_CHAIN_ITEMS.OUTPUT_BUFFER],
    id: SVG_IDS.OUTPUT_AMPLIFIER.NAME,
  },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.REFERENCE.ID },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.DAC.ID },
  { type: ALTERATION_TYPES.ADD_OUTPUT_VOLTAGE, id: OUTPUT_VOLTAGE.OUTPUT.ID },
];
fastPrecisionDac[`${INPUTS.VOLTAGE_REFERENCE}${OPTIONS.INTERNAL}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.VOLTAGE_REFERENCE.GROUP },
];
fastPrecisionDac[`${INPUTS.VOLTAGE_REFERENCE}${OPTIONS.EXTERNAL}`] = [
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.INTERNAL_VOLTAGE_REFERENCE.GROUP },
  { type: ALTERATION_TYPES.HIDE, id: OUTPUT_VOLTAGE.DAC.HIDE },
];
fastPrecisionDac[`${INPUTS.FP_NON_INVERTING}${OPTIONS.NO_BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Non-Inverting_Amplifier' },
  { type: ALTERATION_TYPES.HIDE, id: 'Non-Inverting_Buffer' },
];
fastPrecisionDac[`${INPUTS.FP_NON_INVERTING}${OPTIONS.BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Non-Inverting_Amplifier' },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Buffer' },
];
fastPrecisionDac[`${INPUTS.FP_NON_INVERTING}${OPTIONS.NON_INVERTING_NO_BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Non-Inverting_Buffer' },
  { type: ALTERATION_TYPES.HIDE, id: 'No_Buffer' },
];

fastPrecisionDac[`${INPUTS.FP_DAC_TYPE}${OPTIONS.DAC_TYPE_VOLTAGE_OUT}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'FPDAC_Current_Out' },
];
fastPrecisionDac[`${INPUTS.FP_DAC_TYPE}${OPTIONS.DAC_TYPE_CURRENT_OUT}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'FPDAC_Voltage_Out' },
  { type: ALTERATION_TYPES.HIDE, id: 'Internal_Buffer_Output_Buffer' },
  { type: ALTERATION_TYPES.HIDE, id: 'Internal_Buffer_No_Output_Buffer' },
];

fastPrecisionDac[`${INPUTS.FP_DAC_OUTPUT}${OPTIONS.BUFFER}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Internal_Buffer_No_Output_Buffer' },
];
fastPrecisionDac[`${INPUTS.FP_DAC_OUTPUT}${OPTIONS.NONE}`] = [
  { type: ALTERATION_TYPES.HIDE, id: 'Output_Amplifier_Highlight' },
  { type: ALTERATION_TYPES.HIDE, id: SVG_IDS.OUTPUT_AMPLIFIER.NAME },
  { type: ALTERATION_TYPES.HIDE, id: 'Buffer_Designator' },
  { type: ALTERATION_TYPES.HIDE, id: 'Internal_Buffer_Output_Buffer' },
  { type: ALTERATION_TYPES.HIDE, id: 'Output_Buffer_Out' },
  { type: ALTERATION_TYPES.CHANGE_TRANSFORM, id: OUTPUT_VOLTAGE.OUTPUT.ID, transform: 'translate(322.34 127.90526)' },
];

export default {
  alterations: {
    voltage_output_dac: voltageOutputDac,
    multiplying_dac: multiplyingDac,
    IoutVoutDac: ioutVoutDac,
    FastPrecisionDac: fastPrecisionDac,
    // current_source_dac: currentSourceDac,
    // current_source_sink_dac: currentSourceSinkDac
  },
};
